// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'element-ui/lib/theme-chalk/index.css'
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import VueDND from 'awe-dnd'
import VModal from 'vue-js-modal'
import 'xe-utils'
import VXETable from 'vxe-table'
import VueHighlightJS from 'vue-highlightjs'
import VueClipboard from 'vue-clipboard2'
import VueQrcode from '@chenfengyuan/vue-qrcode'
import VXETablePluginExportXLSX from 'vxe-table-plugin-export-xlsx'
import '@/helper/global'
import 'vxe-table/lib/style.css'

Vue.use(VueClipboard)
Vue.use(VueHighlightJS)
Vue.use(VModal, { dialog: true })
Vue.use(VXETable)
Vue.use(VueDND)
VXETable.use(VXETablePluginExportXLSX)
Vue.component(VueQrcode.name, VueQrcode)
Vue.config.productionTip = false
Vue.use(ElementUI)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js